import { render, staticRenderFns } from "./NewEditAtendimentoPage.vue?vue&type=template&id=49cd3945&scoped=true"
import script from "./NewEditAtendimentoPage.vue?vue&type=script&lang=js"
export * from "./NewEditAtendimentoPage.vue?vue&type=script&lang=js"
import style0 from "./NewEditAtendimentoPage.vue?vue&type=style&index=0&id=49cd3945&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cd3945",
  null
  
)

export default component.exports